<div id="loginCard" class="flex items-center gap-3">
  @if(fetched()){
  <!-- <button class="relative flex items-center">
      <app-icon class="text-gray-400" name="solar:bell-bold"></app-icon>
      <div class="absolute top-0 right-0 rounded-full size-1 bg-xxlist"></div>
    </button> -->
  @if(user(); as user){
  <button class="flex items-center gap-2" mat-button [cdkMenuTriggerFor]="menu">
    <app-profile-image size="sm" [src]="user.profileImage || ''" />
    <p class="hidden font-bold text-neutral-600 md:block">
      {{ user.nickname }}
    </p>
  </button>
  } @else if (showLoginButton()) {
  <button
    (click)="openLoginModal()"
    class="px-3 py-2 text-sm font-semibold text-white bg-primary-500 rounded-xl"
  >
    로그인
  </button>

  } }
</div>

<ng-template #menu>
  <div
    class="flex flex-col py-2 bg-white rounded-md shadow-lg w-28 border-gray-50"
    cdkMenu
  >
    <button
      (click)="myPage()"
      class="px-4 py-2 example-menu-item hover:bg-neutral-100"
      cdkMenuItem
    >
      <p class="text-sm font-medium text-left text-neutral-800">마이페이지</p>
    </button>
    <button
      (click)="logout()"
      class="px-4 py-2 example-menu-item hover:bg-neutral-100"
      cdkMenuItem
    >
      <p class="text-sm font-medium text-left text-neutral-800">로그아웃</p>
    </button>
  </div>
</ng-template>
